// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_q8-5";
export var filledCircle = "_q8-4";
export var historyEntry = "_q8-3";
export var messageSideLeft = "_q8-1";
export var messageSideRight = "_q8-2";
export var orderTrackingCarouselWrapper = "_q8-6";
export var orderTrackingInfoContainer = "_q8-0";